/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { PageMetadata } from './PageMetadata';
import {
    PageMetadataFromJSON,
    PageMetadataFromJSONTyped,
    PageMetadataToJSON,
    PageMetadataToJSONTyped,
} from './PageMetadata';
import type { PublistMetadata } from './PublistMetadata';
import {
    PublistMetadataFromJSON,
    PublistMetadataFromJSONTyped,
    PublistMetadataToJSON,
    PublistMetadataToJSONTyped,
} from './PublistMetadata';

/**
 * 
 * @export
 * @interface PagedModelPublistMetadata
 */
export interface PagedModelPublistMetadata  {
    /**
     * 
     * @type {Array<PublistMetadata>}
     * @memberof PagedModelPublistMetadata
     */
    content?: Array<PublistMetadata>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelPublistMetadata
     */
    page?: PageMetadata;
}

/**
 * Check if a given object implements the PagedModelPublistMetadata interface.
 */
export function instanceOfPagedModelPublistMetadata(value: object): value is PagedModelPublistMetadata {
    return true;
}

export function PagedModelPublistMetadataFromJSON(json: any): PagedModelPublistMetadata {
    return PagedModelPublistMetadataFromJSONTyped(json, false);
}

export function PagedModelPublistMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedModelPublistMetadata {
    if (json == null) {
        return json;
    }
    return {
        
              'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(PublistMetadataFromJSON)),
                  'page': json['page'] == null ? undefined : PageMetadataFromJSON(json['page']),
    };
}

export function PagedModelPublistMetadataToJSON(json: any): PagedModelPublistMetadata {
    return PagedModelPublistMetadataToJSONTyped(json, false);
}

export function PagedModelPublistMetadataToJSONTyped(value?: PagedModelPublistMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'] == null? value['content']: (value['content'] as Array<any>).map(PublistMetadataToJSON),
        'page': PageMetadataToJSON(value['page']),
    };
}


